// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from Slider-Dots.module.scss  */
.Slider-Dots-module-Root_RCd {
  overflow: hidden;
  margin: auto; }

.Slider-Dots-module-List_37Q {
  display: flex;
  margin: 0;
  padding: 1rem 0 4px;
  list-style-type: none;
  transition: transform 100ms; }

.Slider-Dots-module-Control_dx8 {
  width: 0.5rem;
  height: 0.5rem;
  margin: 0 0.4rem;
  padding: 0;
  font-size: 0;
  line-height: 0;
  cursor: pointer;
  color: currentColor;
  border: 0;
  border-radius: 50%; }
  .Slider-Dots-module-Control_dx8:focus-visible {
    outline: 4px solid var(--color-control-border-color-focus); }

.Slider-Dots-module-Dot_aU9 {
  position: relative;
  display: flex; }
  .Slider-Dots-module-Dot_aU9 .Slider-Dots-module-Control_dx8 {
    background-color: #8b8b8b; }
  .Slider-Dots-module-Dot_aU9[aria-selected='true'] .Slider-Dots-module-Control_dx8 {
    background-color: #424242; }
  .Slider-Dots-module-Dot_aU9[aria-hidden='true'] {
    opacity: 0; }
  .Slider-Dots-module-Dot_aU9.Slider-Dots-module-isMuted_3mG .Slider-Dots-module-Control_dx8 {
    background-color: rgba(130, 130, 130, 0.4); }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Slider/Dots/Slider-Dots.css"],"names":[],"mappings":"AAAA,4CAA4C;AAC5C;EACE,gBAAgB;EAChB,YAAY,EAAE;;AAEhB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B,EAAE;;AAE/B;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,UAAU;EACV,YAAY;EACZ,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,kBAAkB,EAAE;EACpB;IACE,0DAA0D,EAAE;;AAEhE;EACE,kBAAkB;EAClB,aAAa,EAAE;EACf;IACE,yBAAyB,EAAE;EAC7B;IACE,yBAAyB,EAAE;EAC7B;IACE,UAAU,EAAE;EACd;IACE,0CAA0C,EAAE","sourcesContent":["/*  imported from Slider-Dots.module.scss  */\n.Slider-Dots-module-Root_RCd {\n  overflow: hidden;\n  margin: auto; }\n\n.Slider-Dots-module-List_37Q {\n  display: flex;\n  margin: 0;\n  padding: 1rem 0 4px;\n  list-style-type: none;\n  transition: transform 100ms; }\n\n.Slider-Dots-module-Control_dx8 {\n  width: 0.5rem;\n  height: 0.5rem;\n  margin: 0 0.4rem;\n  padding: 0;\n  font-size: 0;\n  line-height: 0;\n  cursor: pointer;\n  color: currentColor;\n  border: 0;\n  border-radius: 50%; }\n  .Slider-Dots-module-Control_dx8:focus-visible {\n    outline: 4px solid var(--color-control-border-color-focus); }\n\n.Slider-Dots-module-Dot_aU9 {\n  position: relative;\n  display: flex; }\n  .Slider-Dots-module-Dot_aU9 .Slider-Dots-module-Control_dx8 {\n    background-color: #8b8b8b; }\n  .Slider-Dots-module-Dot_aU9[aria-selected='true'] .Slider-Dots-module-Control_dx8 {\n    background-color: #424242; }\n  .Slider-Dots-module-Dot_aU9[aria-hidden='true'] {\n    opacity: 0; }\n  .Slider-Dots-module-Dot_aU9.Slider-Dots-module-isMuted_3mG .Slider-Dots-module-Control_dx8 {\n    background-color: rgba(130, 130, 130, 0.4); }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
